import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Drawer,
  Select,
  Cascader,
  Upload,
  message,
  Modal
} from "antd";
import city from "components/city";
import {
  customerInfo,
  companyCreate,
  companyUpdate,
  getIndustry,
  companyUsrCreate,
  companySearchName
} from "apis/admin";
import "../../managerCommon.css";
import { phoneReg } from "components/common";
import {
  LoadingOutlined,
  PlusOutlined,
  CloseCircleOutlined
} from "@ant-design/icons";
import { showMessage, baseUrl } from "utils";
import { getToken } from "pages/myutils/user";
// import { setCompanyId } from "apis/user";
import TextArea from "antd/lib/input/TextArea";
import { formItemLayout, tailFormItemLayout } from "../../../login/layout";

const { Option } = Select;
const AddFn = ({ listData, visible, onClose, onGetList, typeSp }) => {
  const [role, token] = getToken();
  const [form] = Form.useForm();
  const [getData, setData] = useState(listData);
  const [files, setFiles] = useState({});
  const [state, setState] = useState({
    loading: false
  });
  const [industryData, setIndustryData] = useState([]);
  const [servicesArr, setServicesArr] = useState([
    {
      type: 1,
      name: "检查吧",
      free: ""
    },
    {
      type: 2,
      name: "问卷吧",
      free: ""
    },
    {
      type: 3,
      name: "督导吧",
      free: ""
    },
    {
      type: 4,
      name: "培训吧",
      free: ""
    }
  ]);
  const scaleArr = [
    "1-9",
    "10-20",
    "21-50",
    "51-100",
    "101-200",
    "201-500",
    "501-2000",
    ">2000"
  ];
  const sourceArr = [
    {
      value: 1,
      text: "企业入驻"
    },
    {
      value: 2,
      text: "测试企业"
    },
    {
      value: 3,
      text: "宣传演示"
    },
    {
      value: 4,
      text: "运营引导"
    }
  ];
  const getIndustryFn = () => {
    getIndustry().then(data => {
      setIndustryData(data);
    });
  };
  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  function beforeUpload(file) {
    setFiles(file);
    console.log(file);
    // 上传图片的格式为 jpg、jpeg、gif、bmp、png
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/jpg" ||
      file.type === "image/gif" ||
      file.type === "image/bmp";
    if (!isJpgOrPng) {
      message.error("只能上传格式为 jpg、jpeg、gif、bmp、png的图片");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("图片必须小于2MB!");
    }
    return isJpgOrPng && isLt2M;
  }
  const { imageUrl } = state;
  const clearImg = (e, type, value) => {
    e.stopPropagation();
    if (type === 1) {
      setState({ ...state, imageUrl: null });
      setData({ ...getData, [value]: null });
      form.setFieldsValue({ [value]: null });
    }
  };
  const uploadButton = (
    <div>
      {state.loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div className="ant-upload-text">上传</div>
    </div>
  );
  const handleChange = info => {
    console.log(info);
    if (info.file.status === "uploading") {
      setState({
        loading: true
      });
      return;
    }
    if (info.file.status === "done") {
      getBase64(info.file.originFileObj, imageUrl =>
        setState({
          imageUrl,
          loading: false
        })
      );
    }
  };
  useEffect(() => {
    if (getData.id) {
      const data = servicesArr.concat([]);
      (getData.services || []).map(x => {
        data.map(y => {
          if (x.serviceType === y.type) {
            y.id = x.serviceId;
            y.free = x.serviceFree;
          }
          return y;
        });
        return x;
      });
      setServicesArr(data);
      setData({
        ...getData,
        username: getData.owner.username,
        industry: getData.industry && getData.industry.split(" / "),
        area: getData.area && getData.area.split(" / ")
      });
      setState({
        imageUrl: getData.logo,
        loading: false
      });
    }
    getIndustryFn();
  }, []);

  const onSubmit = values => {
    // const services = [];
    // servicesArr.map(x => {
    //   if (x.free) {
    //     if (x.id) {
    //       services.push({ type: x.type, free: x.free, id: x.id });
    //     } else {
    //       services.push({ type: x.type, free: x.free });
    //     }
    //   }
    //   return x;
    // });
    // values.services = services;
    values.name = values.name.replace(/\s+/g, "");
    // if (values.industry) {
    //   values.industry = values.industry.join(" / ");
    // }
    values.area = values.area.join(" / ");
    // eslint-disable-next-line no-restricted-syntax,guard-for-in
    for (const x in getData) {
      if (!values[x]) {
        values[x] = getData[x];
      }
    }
    if (state.imageUrl) {
      values.logo = values.logo.file ? values.logo.file.response : values.logo;
    } else {
      values.logo = "";
    }
    if (!getData.id) {
      if (!typeSp) {
        // if (!values.source) {
        //   values.source = 0;
        // }
        companyCreate(values).then(() => {
          showMessage("success", "添加成功");
          onGetList({ length: 10, page: 0, name: "" });
          onClose();
        });
      } else {
        companyUsrCreate(values).then(() => {
          // setCompanyId({ companyId: res.id });
          Modal.info({
            title: "提示",
            content: "添加成功，现在帮您切换到该企业",
            onOk() {
              window.location.reload();
            }
          });
          // onGetList({ length: 10, page: 0, name: "" });
          // onClose();
        });
      }
    } else {
      companyUpdate(values).then(() => {
        showMessage("success", "修改成功");
        onGetList();
        onClose();
      });
    }
  };
  return (
    <Drawer
      title={`${getData.id ? "编辑" : "新建"}企业`}
      placement="right"
      closable
      onClose={onClose}
      visible={visible}
      width={600}
    >
      <Form {...formItemLayout} initialValues={getData} onFinish={onSubmit}>
        <Form.Item
          label="公司名称"
          name="name"
          rules={[
            {
              required: true,
              message: "请输入公司名称"
            },
            () => ({
              validator(rule, value) {
                if (value) {
                  const finnal = value.replace(/\s+/g, "");
                  if (finnal.length < 4 || finnal.length > 120) {
                    // eslint-disable-next-line prefer-promise-reject-errors
                    return Promise.reject("请输入4-120个字符");
                  }
                  if (
                    finnal.indexOf("调研工场") !== -1 ||
                    finnal.indexOf("调研工厂") !== -1
                  ) {
                    // eslint-disable-next-line prefer-promise-reject-errors
                    return Promise.reject(
                      "新建企业不可以包含“调研工场”或“调研工厂”字样"
                    );
                  }
                  return companySearchName({ name: value }).then(data => {
                    console.log(data);
                    if (value === getData.name) {
                      return Promise.resolve();
                    }
                    if (data.id) {
                      // eslint-disable-next-line prefer-promise-reject-errors
                      return Promise.reject("该企业已存在");
                    }

                    return Promise.resolve();
                  });
                }
                return Promise.resolve();
              }
            })
          ]}
        >
          <Input placeholder="请输入公司名称(4-120个字符)" maxLength={120} />
        </Form.Item>
        {/* <Form.Item
          label="所属行业"
          name="industry"
          rules={[
            {
              required: true,
              message: "请选择所属行业"
            }
          ]}
        >
          <Cascader
            options={industryData}
            placeholder="请选择所属行业"
            fieldNames={{
              label: "label",
              value: "label",
              children: "children"
            }}
          />
        </Form.Item> */}
        <Form.Item
          label="公司地址"
          name="area"
          rules={[
            {
              required: true,
              message: "请选择公司地址"
            }
          ]}
        >
          <Cascader
            options={city}
            placeholder="请选择公司地址"
            fieldNames={{
              label: "label",
              value: "label",
              children: "children"
            }}
          />
        </Form.Item>
        <Form.Item
          label="详细地址"
          name="address"
          rules={[
            {
              required: true,
              message: "请输入详细地址"
            },
            () => ({
              validator(rule, value) {
                if (value) {
                  const finnal = value.replace(/\s+/g, "");
                  if (finnal.length < 4 || finnal.length > 120) {
                    // eslint-disable-next-line prefer-promise-reject-errors
                    return Promise.reject("请输入4-120个字符");
                  }
                  return Promise.resolve();
                }
                return Promise.resolve();
              }
            })
          ]}
        >
          <Input placeholder="请输入详细地址(4-120个字符)" maxLength={120} />
        </Form.Item>
        <Form.Item
          label="负责人"
          name="principal"
          rules={[
            {
              required: true,
              message: "请输入负责人"
            }
          ]}
        >
          <Input placeholder="请输入负责人" />
        </Form.Item>
        <Form.Item
          label="联系电话"
          name="telephone"
          rules={[
            {
              required: true,
              message: "请输入联系电话"
            },
            () => ({
              validator(rule, value) {
                const regex = phoneReg;
                if (value) {
                  // setData({ ...getData, owner: null });
                  if (regex.test(value)) {
                    // return customerInfo({ mobile: value }).then(data => {
                    //   if (data.id === 0) {
                    //     console.log(data);
                    //     // eslint-disable-next-line prefer-promise-reject-errors
                    //     return Promise.reject(
                    //       "该手机号还未注册，无法添加为主管理员"
                    //     );
                    //   }
                    //   setData({ ...getData, owner: data });

                    // });
                    return Promise.resolve();
                  }
                  // eslint-disable-next-line prefer-promise-reject-errors
                  return Promise.reject("手机号格式错误");
                }
                return Promise.resolve();
              }
            })
          ]}
        >
          <Input placeholder="请输入联系电话" />
        </Form.Item>
        <Form.Item
          label="公司邮箱"
          name="email"
          rules={[
            {
              required: true,
              message: "请输入公司邮箱"
            }
          ]}
        >
          <Input placeholder="请输入公司邮箱" />
        </Form.Item>
        <Form.Item label="logo" name="logo">
          <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            action={`${baseUrl}/fileStorage/uploadFile`}
            data={file => ({
              file: files,
              token
            })}
            beforeUpload={beforeUpload}
            onChange={handleChange}
          >
            {imageUrl ? (
              <div className="xfCloseBox">
                <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
                <a
                  href="JavaScript:;"
                  title="清除图片"
                  onClick={e => clearImg(e, 1, "logo")}
                >
                  <CloseCircleOutlined />
                </a>
              </div>
            ) : (
              uploadButton
            )}
          </Upload>
        </Form.Item>
        <div className="mark" style={{ marginLeft: 0 }}>
          允许上传图片的格式为 jpg、jpeg、gif、bmp、png
          <br />
          建议尺寸大小：100 x 100 像素
        </div>
        {/* <Form.Item
          label="使用服务"
          name="services"
          rules={[
            {
              required: true,
              message: "请至少选择一种服务"
            }
          ]}
        >
          <div className="severBox">
            {servicesArr.map(x => {
              return (
                <div className="box">
                  <span className="title">{x.name}</span>
                  <Radio.Group
                    defaultValue={x.free}
                    onChange={e => {
                      const index = servicesArr.indexOf(x);
                      const data = servicesArr.concat([]);
                      const { value } = e.target;
                      data[index].free = value;
                      setServicesArr(data);
                    }}
                  >
                    <Radio value={1}>免费</Radio>
                    <Radio value={2}>收费</Radio>
                  </Radio.Group>
                </div>
              );
            })}
          </div>
        </Form.Item> */}
        <br />
        {!typeSp && (
          <div>
            <Form.Item label="企业来源" name="source">
              <Select
                placeholder="请选择"
                disabled={typeSp}
                defaultValue={typeSp && "企业入驻"}
              >
                {sourceArr.map(x => {
                  return <Option value={x.value}>{x.text}</Option>;
                })}
              </Select>
            </Form.Item>
            <Form.Item label="企业备注" name="note">
              <TextArea placeholder="请输入" />
            </Form.Item>
            <Form.Item
              label="主管理员手机号"
              name="username"
              rules={[
                {
                  required: true,
                  message: "请输入主管理员手机号"
                },
                () => ({
                  validator(rule, value) {
                    const regex = phoneReg;
                    if (value) {
                      setData({ ...getData, owner: null });
                      if (regex.test(value)) {
                        return customerInfo({ mobile: value }).then(data => {
                          if (data.id === 0) {
                            console.log(data);
                            // eslint-disable-next-line prefer-promise-reject-errors
                            return Promise.reject(
                              "该手机号还未注册，无法添加为主管理员"
                            );
                          }
                          setData({ ...getData, owner: data });
                          Promise.resolve();
                        });
                      }
                      // eslint-disable-next-line prefer-promise-reject-errors
                      return Promise.reject("手机号格式错误");
                    }
                    return Promise.resolve();
                  }
                })
              ]}
            >
              <Input placeholder="请输入主管理员手机号" />
            </Form.Item>
            {getData.owner && getData.owner.name && (
              <p>管理员名称：{getData.owner.name}</p>
            )}
          </div>
        )}

        <Form.Item
          {...tailFormItemLayout}
          className="btns"
          style={{ textAlign: "right", marginTop: 40 }}
        >
          <Button type="primary" htmlType="submit">
            确认
          </Button>
          <Button
            type="primary"
            className="grayBtn"
            onClick={() => {
              onClose();
            }}
          >
            取消
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default AddFn;
